"use strict";

exports.onRouteUpdate = function (_ref) {
  var location = _ref.location;

  // Don't track while developing.
  if (process.env.NODE_ENV === "production" && typeof ga === "function") {
    // Wait for the title update (see #2478)
    setTimeout(function () {
      window.ga("set", "page", (location || {}).pathname);
      window.ga("send", "pageview");
    }, 0);
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-google-analytics/gatsby-browser.js
// module id = 412
// module chunks = 231608221292675